import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { printQuotedmgc3s3pgfors as printQuoted } from './StringOps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonToStringWriterClass;
function JsonToStringWriter() {
  if (JsonToStringWriterClass === VOID) {
    class $ {
      constructor() {
        this.w2m_1 = StringBuilder().ub(128);
      }
      b2s(value) {
        this.w2m_1.vg(value);
      }
      v2r(char) {
        this.w2m_1.o1(char);
      }
      x2r(text) {
        this.w2m_1.m1(text);
      }
      h2s(text) {
        printQuoted(this.w2m_1, text);
      }
      x2m() {
        this.w2m_1.yg();
      }
      toString() {
        return this.w2m_1.toString();
      }
    }
    initMetadataForClass($, 'JsonToStringWriter', JsonToStringWriter);
    JsonToStringWriterClass = $;
  }
  return JsonToStringWriterClass;
}
//region block: exports
export {
  JsonToStringWriter as JsonToStringWriter25agxcyem0yhk,
};
//endregion

//# sourceMappingURL=JsonToStringWriterJsWasm.mjs.map
